import { useRef, useEffect,useState } from "react";

import { Button } from "@mui/material";
import StarterKit from "@tiptap/starter-kit";
import {
  MenuButtonBold,
  MenuButtonItalic,
  MenuButtonBulletedList,
  MenuButtonOrderedList,
  MenuControlsContainer,
  MenuDivider,
  RichTextEditor
} from "mui-tiptap";

import { Container } from "./styles";

const TextEditor = (props) => {
  const {
    id,
    value,
    buttonProps,
    readOnly = false,
    onButtonClick = () => {},
    onBlur = () => {},
    onUpdate = () => {},
    label,
    sx,
    isDisabled
  } = props;

  const rteRef = useRef(null);
  const editor = rteRef.current?.editor;
  const [editorContent, setEditorContent] = useState(value);

  useEffect(() => {
    if (rteRef.current?.editor && value !== editorContent) {
      rteRef.current.editor.commands.setContent(value);
      setEditorContent(value);
    }
  }, [value]);

  const renderButton = () => {
    if (buttonProps) {
      return (
        <Button
          {...buttonProps}
          className="text-editor-button"
          onClick={handleButtonClick}
          disabled={isDisabled}
        >
          {buttonProps.label}
        </Button>
      );
    }
  };

  const handleButtonClick = () => {
    onButtonClick(rteRef.current?.editor?.getHTML(), id);
    editor.chain().setContent(value).run();
  };

  const handleBlur = () => {
    setEditorContent(rteRef.current?.editor?.getHTML());
    onBlur(rteRef.current?.editor?.getHTML(), id);
  };

  const handleUpdate = () => {
    setEditorContent(rteRef.current?.editor?.getHTML());
    onUpdate(rteRef.current?.editor?.getHTML(), id);
  };

  return (
    <Container>
      <div className="text-editor">
        <RichTextEditor
          label={label} // Optional label for the editor
          sx={sx} // Optional sx prop for styling the editor
          ref={rteRef}
          extensions={[StarterKit]} // Or any Tiptap extensions you wish!
          content={editorContent} // Initial content for the editor
          lines={5} // Number of lines for the editor
          onBlur={handleBlur}
          onUpdate={handleUpdate}
          renderControls={() => (
            <MenuControlsContainer>
              <MenuButtonBold />
              <MenuButtonItalic />
              <MenuDivider />
              <MenuButtonBulletedList />
              <MenuButtonOrderedList />
              {/* Add more controls of your choosing here */}
            </MenuControlsContainer>
          )}
        />

        {renderButton()}
      </div>      
    </Container>

  );
};

export default TextEditor;
